/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Row, Spinner } from 'reactstrap'
import JobHistoryCard from './jobHistoryCard'
import Pagination from './JobListOne/Pagination'
import { applyJobHistory } from '../../api/applyJobApi'
import { useTranslation } from 'react-i18next'

const JobHistory = () => {
    const [count, setCount] = useState(0);
    const [jobList, setJobList] = useState([]);
    const [lastId, setLastId] = useState(0);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation()
    const handleGetHistory = async () => {
        setIsLoading(true)
        await applyJobHistory(lastId)
            .then((result) => {
                if (result.data.success) {
                    setJobList(result.data.applyJob)
                    if (lastId === 0) {
                        setCount(result.data.count)
                    }
                }
                setIsLoading(false)
            }).catch((err) => {
                console.log(err)
                setIsLoading(false)
            });
    }
    useEffect(() => {
        handleGetHistory()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lastId]);
    return (
        <>
            <section className="section min-vh-100">
                <Container>
                    <Row className='justify-content-center'>
                        <Col lg="11" xl="10">
                            <Card className='mt-5 border-0 p-sm-4 rounded-4 shadow_4'>
                                {isLoading ? <div className='pt-5 pb-2 text-center'><Spinner /></div> :
                                    <>
                                        {jobList?.length > 0 ?
                                            <>
                                                <Row className='justify-content-center g-2'>
                                                    <Col xs={12} className="">
                                                        <div className="section-title d-flex justify-content-between gap-3 flex-wrap align-items-center">
                                                            <h5 className="mb-0">{t('appilied_heading')} :</h5>
                                                        </div>
                                                    </Col>
                                                    {(jobList || []).filter(job => job?.postJob !== null).map((item, key) => (
                                                        <Col key={key} xs={12} className="">
                                                            <JobHistoryCard item={item} />
                                                        </Col>
                                                    ))}
                                                </Row>

                                            </>
                                            :
                                            <div className='pt-5 pb-2 text-center'>
                                                {jobList?.length <= 0 &&
                                                    t('job_not')}
                                            </div>}
                                    </>}
                                {jobList?.length > 0 &&
                                    <Pagination count={count} setLastId={setLastId} isLoading={isLoading} />}
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default JobHistory